import { CSSProperties, forwardRef } from "react";
import { Image, ImageProps } from "@chakra-ui/react";

/**
 * An Image component that prevents right-click context menu (save image as),
 * native image drag, and text-selection highlighting (which otherwise paints
 * a blue overlay when users click-drag across pages in the reader).
 * Use this for content images that need piracy protection (comic covers, pages, etc.)
 */
export const ProtectedImage = forwardRef<HTMLImageElement, ImageProps>(
  ({ style, ...props }, ref) => {
    return (
      <Image
        {...props}
        ref={ref}
        draggable={false}
        userSelect="none"
        onContextMenu={(e) => e.preventDefault()}
        // Safari: suppress native image drag (not in React's CSSProperties type)
        style={{ ...style, WebkitUserDrag: "none" } as CSSProperties}
      />
    );
  },
);

ProtectedImage.displayName = "ProtectedImage";
